import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Event, NavigationEnd, NavigationStart, Router, RouterEvent } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { LogoutAction } from 'src/app/actions/auth.actions';
import { NegotiationsApiService } from 'src/app/api/negotiations-api.service';
import { FinancialStatus } from 'src/app/models/account-status.model';
import { AccountState } from 'src/app/states/account.state';
import { AuthState } from 'src/app/states/auth.state';
import Swal from 'sweetalert2';
import { ChartRoseIcon, ArrowRight01Icon, BookOpenTextIcon, AuctionIcon, Chat01Icon, Home09Icon, BadgeInfoIcon, CoinsDollarIcon, PayByCheckIcon, LogoutSquare02Icon, UserIcon } from '@hugeicons-pro/core-stroke-rounded';


@Component({
  selector: 'app-sidebar-content',
  templateUrl: './sidebar-content.component.html',
  styleUrls: ['./sidebar-content.component.css']
})
export class SidebarContentComponent implements OnInit {
  @Output() navigate = new EventEmitter<void>();

  @Select(AuthState.getUserInfo)
  userInfo$;
  @Select(AccountState.getUserType)
  userType$;
  @Select(AccountState.getAccountStatus)
  accountStatus$;
  financialStatus = FinancialStatus;

  Home09Icon = Home09Icon;
  PayByCheckIcon = PayByCheckIcon;
  ArrowRight01Icon = ArrowRight01Icon;
  CoinsDollarIcon = CoinsDollarIcon;
  AuctionIcon = AuctionIcon;
  Chat01Icon = Chat01Icon;
  BookOpenTextIcon = BookOpenTextIcon;
  ChartRoseIcon = ChartRoseIcon;
  UserIcon = UserIcon;
  BadgeInfoIcon = BadgeInfoIcon;
  LogoutSquare02Icon = LogoutSquare02Icon;


  hasUnread$ = this.negotiationsApi.hasUnreadMessages$;

  isLogin: boolean = false;

  private destroy$ = new Subject<void>();

  splitVal;
  base;
  page;
  showProfile = false;
  showRegister = false;
  showAccounts = false;
  isCollapsed: boolean;
  isAccountNavbarCollapsed: boolean = true;
  isInvestNavbarCollapsed: boolean = true;
  isFinancingNavbarCollapsed: boolean = true;
  isChecksNavbarCollapsed: boolean = true;
  isOffersNavbarCollapsed: boolean = true;
  isOperationsNavbarCollapsed: boolean = true;
  isAboutNavbarCollapsed: boolean = true;
  isChatNavbarCollapsed: boolean = true;

  constructor(private store: Store, public router: Router, private negotiationsApi: NegotiationsApiService) {
      this.listenToRouteEvents();
    }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  logout() {
    this.store.dispatch(new LogoutAction());
  }

  private listenToRouteEvents() {
    this.router.events.subscribe((event: Event | RouterEvent) => {
      if (event instanceof NavigationStart) {
        this.splitVal = event.url.split('/');
        this.base = this.splitVal[1];
        this.page = this.splitVal[2];
        const body = document.getElementsByTagName('body')[0];
        if (this.base === 'login') {
          this.isLogin = true;
        } else {
          this.isLogin = false;
        }
        if (this.base === 'dashboard' || this.base === 'user-account-details'
          || this.base === 'manage-projects' || this.base === 'favourites' || this.base === 'membership-plans' || this.base === 'milestones'
          || this.base === 'chats' || this.base === 'review' || this.base === 'deposit-funds' || this.base === 'verify-identity'
          || this.base === 'profile-settings') {
          this.showProfile = true;
          this.showRegister = false;
          this.showAccounts = false;
        } else if (this.base === 'home' || this.base === 'developer' || this.base === 'developer-details' || this.base === 'project'
          || this.base === 'project-details' || this.base === 'about' || this.base === 'blank-page' || this.base === '404-page'
          || this.base === 'user-account-details' || this.base === 'login' || this.base === 'register' || this.base === 'forgot-password'
          || this.base === 'change-password' || this.base === 'blog-list' || this.base === 'blog-grid' || this.base === 'blog-details') {
          this.showProfile = false;
          this.showRegister = true;
          this.showAccounts = false;
        } else if (
          this.base === 'freelancer-dashboard' || this.base === 'freelancer-project-proposals' || this.base === 'freelancer-membership' || this.base === 'freelancer-favourite'
          || this.base === 'freelancer-change-password' || this.base === 'freelancer-chats' || this.base === 'freelancer-review' || this.base === 'freelancer-withdraw-money'
          || this.base === 'freelancer-verify-identity' || this.base === 'freelancer-profile-settings' || this.base === 'freelancer-invoices' || this.base === 'view-invoice') {
          this.showProfile = false;
          this.showRegister = false;
          this.showAccounts = true;
        }
        if (this.base === 'home') {
          body.classList.add('home-page');
          body.classList.remove('dashboard-page');
        } else if (this.base === 'chats' || this.base === 'freelancer-chats') {
          body.classList.add('chat-page');
          body.classList.remove('dashboard-page');
        } else if (this.base === 'blog-list' || this.base === 'blog-grid' || this.base === 'blog-details' || this.base === 'project' || this.base === 'developer' || this.base === 'post-project') {
          body.classList.remove('dashboard-page');
        } else {
          body.classList.add('dashboard-page');
          body.classList.remove('home-page');
        }
      }
      if (event instanceof NavigationEnd) {
        this.isAccountNavbarCollapsed = true;
        this.isInvestNavbarCollapsed = true;
        this.isFinancingNavbarCollapsed = true;
        this.isChecksNavbarCollapsed = true;
        this.isOffersNavbarCollapsed = true;
        this.isOperationsNavbarCollapsed = true;
        this.isAboutNavbarCollapsed = true;
        this.isChatNavbarCollapsed = true;
      }
    });
  }

  toggleAccountMenu() {
    if (this.isAccountNavbarCollapsed == false) {
      this.isAccountNavbarCollapsed = true;
    } else {
      this.isAccountNavbarCollapsed = false;
    }
  }
  
  toggleInvestMenu() {
    if (this.isInvestNavbarCollapsed == false) {
      this.isInvestNavbarCollapsed = true;
    } else {
      this.isInvestNavbarCollapsed = false;
    }
  }
  
  toggleFinancingMenu() {
    if (this.isFinancingNavbarCollapsed == false) {
      this.isFinancingNavbarCollapsed = true;
    } else {
      this.isFinancingNavbarCollapsed = false;
    }
  }

  toggleChecksMenu() {
    if (this.isChecksNavbarCollapsed == false) 
      this.isChecksNavbarCollapsed = true;
    else 
      this.isChecksNavbarCollapsed = false;
  }

  toggleOffersMenu() {
    if (this.isOffersNavbarCollapsed == false) 
      this.isOffersNavbarCollapsed = true;
    else 
      this.isOffersNavbarCollapsed = false;
  }

  toggleChatMenu() {
    if (this.isChatNavbarCollapsed == false) 
      this.isChatNavbarCollapsed = true;
    else 
      this.isChatNavbarCollapsed = false;
  }

  toggleOperationsMenu() {
    if (this.isOperationsNavbarCollapsed == false) 
      this.isOperationsNavbarCollapsed = true;
    else 
      this.isOperationsNavbarCollapsed = false;
  }

  toggleAboutMenu() {
    if (this.isAboutNavbarCollapsed == false) {
      this.isAboutNavbarCollapsed = true;
    } else {
      this.isAboutNavbarCollapsed = false;
    }
  }

  isProfileSubmenuActive(): boolean {
    return this.router.url.includes('/user-account-details') || this.router.url.endsWith('/perfil-publico/mi-perfil-publico')
    || this.router.url.endsWith('/mi-documentacion') || this.router.url.endsWith('/recibos-facturas') || this.router.url.endsWith('/referral');;
  }

  isFinancingSubmenuActive(): boolean {
    return this.router.url.includes('/perfil-publico/mis-pedidos') || this.router.url.includes('/perfil-publico/inversiones-financiamiento') || this.router.url.includes('/invertir/lineas-credito') || this.router.url.includes('/perfil-publico/nueva-solicitud');
  }

  isInvestSubmenuActive(): boolean {
    return this.router.url.includes('/invertir');
  }

  isChecksSubmenuActive(): boolean {
    return this.router.url.includes('/descontar') || this.router.url.includes('/invertir/cheques') || this.router.url.includes('/portfolio');
  }

  isOffersSubmenuActive(): boolean {
    return this.router.url.includes('/ofertas') || this.router.url.includes('/perfil-publico/ofertas');
  }
  
  isOperationsSubmenuActive(): boolean {
    return this.router.url.includes('/dashboard') || this.router.url.includes('/transaccion-list');
  }

  isChatSubmenuActive(): boolean {
    return this.router.url.includes('/perfil-publico/mis-negociaciones') || this.router.url.includes('/perfil-publico/mis-preguntas');
  }

  isAboutSubmenuActive(): boolean {
    return this.router.url.includes('/contacto');
  }

  handleNavigate(): void {
    this.navigate.emit();
  }

  preguntasPublicas() {
    Swal.fire({
      title: 'No disponible', 
      text: 'Este sector no se encuentra disponible aún', 
      icon:'warning',
      confirmButtonText: 'Esperar'
    }).then(res => {
      if (res.isConfirmed) {
        window.open('https://www.youtube.com/watch?v=xm3YgoEiEDc&list=RDxm3YgoEiEDc&start_radio=1', '_blank');
      }
    })
  }
}